import React, { useState } from 'react';
import ReactGA from 'react-ga';
import View from './View';

import {
  generateSkaters,
  generateGoalies,
  generateInitalLiveData,
  generateFinalStats,
  generateTeamData,
  generatePeriods,
  generateOfficialsData,
  generateVenueData
} from './util/static';
import { generateInitialHeartbeat } from './util/live';
import useInterval from '@/hooks/useInterval';




function GameController({ data, output }) {
  // Static Data
  const venue = generateVenueData(data);
  const teams = generateTeamData(data);
  const officials = generateOfficialsData(data);
  const finalStats = generateFinalStats(data);
  const periods = generatePeriods(data);
  const skaters = generateSkaters(data);
  const goalies = generateGoalies(data);

  // State
  const [isPaused, setIsPaused] = useState(false);
  const [liveData, setLiveData] = useState(generateInitalLiveData(data));
  const [heartbeat, setHeartbeat] = useState(generateInitialHeartbeat());

  function setSpeed(speed){
    ReactGA.event({
      category: 'Speed',
      action: 'Changed Simulation Speed',
      label: `New Speed: ${speed}`,
    });

    setHeartbeat({...heartbeat, speed});
  }

  function handlePause(){
    const paused = !isPaused;

    if(paused){
      setHeartbeat({...heartbeat, delay: null });
      ReactGA.event({
        category: 'Paused',
        action: 'Paused Simulation'
      });
    } else {
      setHeartbeat({...heartbeat, delay: 1 })
    }

    setIsPaused(paused);
  }

  // Run the interval
  useInterval(() => {
    const [newData, newHeartbeat] = heartbeat.nextFn(liveData, heartbeat, periods);

    setLiveData(newData);
    setHeartbeat(newHeartbeat);
  }, heartbeat.delay);

  return (
    <View
      clock={liveData.clock}
      date={data.date}
      events={liveData.pastEvents}
      goalies={goalies}
      goals={liveData.goals}
      isFinal={liveData.period.isFinal}
      isPaused={isPaused}
      notes={liveData.notes}
      officials={officials}
      onPause={handlePause}
      onSpeedChange={setSpeed}
      penalties={liveData.penalties}
      period={liveData.period}
      periods={periods}
      skaters={skaters}
      speed={heartbeat.speed}
      shootout={liveData.shootout}
      stats={liveData.period.isFinal ? finalStats : liveData.stats}
      teams={teams}
      threeStars={data.threeStars}
      venue={venue}
      output={output}
    />
  );
}

export default GameController;
